<div class="payment-history">
    <mat-accordion multi class="mat-table">
      <section class="mat-header-row">
        <span class="mat-header-cell" *ngFor="let col of paymentHistoryHeaders">{{col}}</span>
      </section>
      <span *ngIf="isLoadingPaymemtHistory">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw mt-4"></i>
      </span>
      <mat-expansion-panel *ngFor="let payment of payments" #exp>
        <mat-expansion-panel-header class="mat-row" matTooltip="CLICK FOR DETAILS" [matTooltipShowDelay]="2000">
          <span class="mat-cell">{{payment.wiDate | validDate}}</span>
          <span class="mat-cell">{{payment.nickName}}</span>
          <span class="mat-cell">{{payment.bankName}}</span>
          <span class="mat-cell">{{payment.accountNumberMasked }}</span>
          <span class="mat-cell">{{payment.amount | currency}}</span>
          <span class="mat-cell">{{payment.scheduleFrequencyName}}</span>
        </mat-expansion-panel-header>
        <div class="container-fluid">
          <table class="table table-bordered table-striped" tabindex="0">
            <thead class="payment-list-header">
              <tr>
                <th *ngFor="let col of payorHistoryHeaders">{{col}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let par of payment.participantCollection">
                <td>{{par.lastName }}</td>
                <td>{{par.firstName}}</td>
                <td *ngIf="showParticipantCase">{{par.secondaryId}}</td>
                <td>{{par.ssn | maskdata: 4}}</td>
                <td>{{par.amount | currency}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  